<h2 mat-dialog-title>
  {{'moveconfirmDialog.confirmation' | translate}}</h2>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'moveconfirmDialog.changesnotSaved' | translate}} </p>
  <p *ngIf='isMove'[innerHTML]="'moveconfirmDialog.saveBeforemoving' | translate"> </p>
  <p *ngIf='!isMove'[innerHTML]="'moveconfirmDialog.saveBeforeclosing' | translate"> </p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions fxFlex fxLayoutAlign="center center">
    <div class="not-save-div">
      <button mat-button color="primary" [mat-dialog-close]="false">{{'moveconfirmDialog.notSave' | translate}}</button>
    </div>
    <span class="spacer"></span>
    <div class="save-div">
      <button mat-button color="primary" mat-dialog-close>{{'moveconfirmDialog.cancel' | translate}}</button>
      <button mat-raised-button color="primary" (click)="save()" cdkFocusInitial [disabled]="isError">{{'moveconfirmDialog.save' | translate}}</button>
    </div>
  </mat-dialog-actions>
</div>